import request from '@/utils/request'

export function transfer(record) {
    let url = '/account/transfer'
    let data = record
    data.json = true
    return request.post(url,record)
}

export function all(userId) {
    let url = '/account/queryAll'
    let params = {userId}
    return request.get(url,{params})
}